import { useAuth } from '../../../hooks/useAuth';
import { signOutUser } from '../../../services/authService';

export default function CompanyLayout({ children }) {
  const { user, userProfile } = useAuth();
  const displayName = user?.displayName || userProfile?.company_name || userProfile?.email || user?.email || 'Company';

  async function handleSignOut() {
    await signOutUser();
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-background)' }}>
      <header style={{
        background: '#1e3a5f',
        color: '#fff',
        padding: '0 24px',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 16, fontWeight: 700, letterSpacing: 0.3 }}>
            Mirepa Investment Advisors
          </span>
          <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>|</span>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)' }}>
            Screening Portal
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)' }}>{displayName}</span>
          <button
            onClick={handleSignOut}
            style={{
              background: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.25)',
              color: '#fff',
              borderRadius: 6,
              padding: '5px 14px',
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Sign Out
          </button>
        </div>
      </header>
      <nav style={{
        background: '#fff',
        borderBottom: '1px solid var(--color-border)',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        height: 44,
      }}>
        <a
          href="/company/dsq"
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: '#1e3a5f',
            textDecoration: 'none',
            padding: '0 4px',
            borderBottom: '2px solid #1e3a5f',
          }}
        >
          My Application
        </a>
      </nav>
      <main style={{ padding: '32px 24px', maxWidth: 900, margin: '0 auto' }}>
        {children}
      </main>
    </div>
  );
}
